import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import { postMember6 } from "../../common/redux/MasterLayoutCRUD";
import { reportSlice } from "./ReportSlice";

const { actions } = reportSlice;

export const getReportPageList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return postMember6(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.reportPageListFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchHomePageUI");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};
